import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { ChartType } from '@/features/_shared/chart/types/highcharts';
import type { Sx } from '@/shared/types/uiTypes';

export type ChartButtonRenderer = (graphType: ChartType, sx?: Sx, iconSize?: number) => ReactNode;

export const ExportChartButtonContext = createContext<ChartButtonRenderer | null>(null);

export const useExportChartButton = () => useContext(ExportChartButtonContext);
